module.exports = __webpack_public_path__ + "img/calendar2-week.2d6857e1.svg";